// extracted by mini-css-extract-plugin
export var dropdownIcon = "_sg-6";
export var imgContainer = "_sg-3";
export var menuIcon = "_sg-5";
export var pillWrapper = "_sg-2";
export var pillsContainer = "_sg-1";
export var subscriptionCard = "_sg-0";
export var subscriptionLogo = "_sg-4";